import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import Global from '../store/global-selectors';
import { Segment } from '../services/analytics-services/segment';
import { UserPermissionService } from '../services/user-permission-service';
import { useNonWalletedAndNonExcludedSellerLabelProviders } from './use-seller-label-providers';
import {
  YOUR_CARRIERS_ACTIVATE_MODAL_OPEN,
  YOUR_CARRIERS_ACTIVATE_MODAL_CLOSE,
  YOUR_CARRIERS_ACTIVATE_COMPLETE,
  YOUR_CARRIERS_DEACTIVATE_COMPLETE,
  YOUR_CARRIERS_SUBSCRIPTION_LINK_CLICK,
} from '../constants/analytics-events';

export const PageEvents = {
  YOUR_CARRIERS_ACTIVATE_MODAL_OPEN,
  YOUR_CARRIERS_ACTIVATE_MODAL_CLOSE,
  YOUR_CARRIERS_ACTIVATE_COMPLETE,
  YOUR_CARRIERS_DEACTIVATE_COMPLETE,
  YOUR_CARRIERS_SUBSCRIPTION_LINK_CLICK,
};

export const useTrackYourCarriersEvent = (eventName, source = '') => {
  const planInfo = useSelector(Global.selectSellerSubscriptionPlanInfo);
  const userRoles = useSelector(Global.selectUseruserRoles);
  const hasAccessToAddNonWalletAccess = UserPermissionService.userHasAccountManagementRole(userRoles);
  const nonWalletedAndNonExcludedSellerLabelProviders = useNonWalletedAndNonExcludedSellerLabelProviders();
  const byoaSellerLabelProviderIds = nonWalletedAndNonExcludedSellerLabelProviders.map((provider) => provider.labelProviderId);

  return useCallback(() => {
    const payload = {
      planCode: planInfo?.planCode,
    };

    if (source) {
      payload.source = source;
    }

    if (eventName === YOUR_CARRIERS_ACTIVATE_MODAL_OPEN) {
      payload.hasAccessToAddNonWalletAccess = hasAccessToAddNonWalletAccess;
    }

    if (eventName === YOUR_CARRIERS_DEACTIVATE_COMPLETE) {
      payload.byoaSellerLabelProviderIds = byoaSellerLabelProviderIds;
    }

    Segment.trackEvent(eventName, payload);
  }, [byoaSellerLabelProviderIds, eventName, hasAccessToAddNonWalletAccess, planInfo?.planCode, source]);
};
